import httpRequest from '@/request'
import Vue from 'vue'
const API = {
    OBS: '/front/energygov/v1/supervisionArchives/obsSettingInfo' 
}
export function getObsSettingRequest() {
    return httpRequest({
      url: API.OBS,
      method: 'get',
    })
}
  